import React, { useEffect } from "react";
import { Redirect } from 'react-router-dom';
import { observer } from "mobx-react";

import { useAuth } from 'services/auth';
import { useStore } from "stores";
import { buildDashboardPath } from "app-router/paths";
import { FormCard } from "components/Card";
import { ErrorMessage } from "components/Message";
import Loading from "components/Loading";

interface Props
{
  error?: Error;
  isLoading?: boolean;
}
export const Page: React.FC<Props> = observer(({error, isLoading}) =>
{
  const authOptions = useAuth();
  const { uiStore } = useStore();
  const pageLables = uiStore.labels.pages.login;

  useEffect(() =>
  {
    if (!authOptions.authStore.currentUser && !error && !isLoading)
    {
      //authOptions.signInAsync();
    }
  }, [authOptions, error, isLoading]);

  useEffect(() =>
  {
    if (error)
    {
      console.log(error);
    }
  }, [error]);

  if (authOptions.authStore.currentUser)
  {
    return <Redirect to={authOptions.authStore.returnUrl ?? buildDashboardPath()} />;
  }
  else
  {
    return (
      <article className="page login">
        <FormCard>
          {
            error
            ? <>
                 <h1>{pageLables.failed.title}</h1>
                <ErrorMessage>{pageLables.failed.explanationLines.map((x, i) => <React.Fragment key={i}>{x}<br/></React.Fragment>)}</ErrorMessage>
              </>
            : <>
                <h1>{pageLables.titleLines.map((x, i) => <React.Fragment key={i}>{x}<br/></React.Fragment>)}</h1>
              </>
          }
          {
            isLoading || authOptions.isInProgress()
            ? <Loading />
            : <div className="actions">
                <button onClick={authOptions.signInAsync}>
                  {
                    error
                    ? pageLables.failed.tryAgain
                    : pageLables.logIn
                  }
                </button>
              </div>
          }
        </FormCard>
      </article>
    );
  }
});
